import { useState } from "react";
import ReportTable from "../components/reportTable";
import { columnsConfig } from "./reportColumns";
import ReportFilters from "../components/reportFilter";

const InterestReport = () => {
  const [filters, setFilters] = useState({ from: "", to: "" });

  return (
    <>
      <ReportFilters filters={filters} setFilters={setFilters} />
      <ReportTable
        title="Interest Received Report"
        endpoint="reports/interest"
        columns={columnsConfig.interestReport}
        filters={filters}
      />
    </>
  );
};

export default InterestReport;